import { useEffect, useState } from 'react'
import { createContext } from 'react'

import last from 'lodash/last'
import nth from 'lodash/nth'
import replace from 'lodash/replace'
import { Router, useRouter } from 'next/router'

interface ContextProps {
  history: string[]
  back: Function
  referrer: string | undefined
}

export const Context = createContext<ContextProps>({
  history: [],
  back: undefined,
  referrer: undefined,
})
Context.displayName = 'RouterHistoryContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const RouterHistory = ({ children }: Props) => {
  const router = useRouter()
  const [history, setHistory] = useState<string[]>([])

  const referrer = nth(history, -2)
  let current = last(history)

  const track = () => {
    const now = replace(window.location.href, window.location.origin, '')
    const newHistory = [...history]

    if (now === nth(newHistory, -2)) {
      newHistory.pop()
      setHistory([...newHistory])
    }

    current = last(newHistory)

    if (now !== current) {
      setHistory([...newHistory, now])
    }
  }

  useEffect(() => {
    if (history.length === 0) {
      track()
    }

    Router.events.on('routeChangeComplete', track)

    return () => {
      Router.events.off('routeChangeComplete', track)
    }
  })

  const handleBack = () => {
    if (
      (referrer === '/' ||
        referrer === '/board' ||
        referrer?.startsWith('/login') ||
        referrer === undefined) &&
      !router.query.content_identifier
    ) {
      router.push('/')
    } else {
      if (!!router.query.content_identifier) {
        if (referrer === undefined) {
          setHistory((prev) => {
            prev.pop()
            return prev
          })
        }
        referrer === `/cc/${router.query.identifier}`
          ? router.back()
          : router.replace(`/cc/${router.query.identifier}`)
      } else {
        router.back()
      }
    }
  }

  const value = {
    history,
    back: () => handleBack(),
    referrer,
  }

  return <Provider value={value}>{children}</Provider>
}

export default RouterHistory
